import styled, { css } from 'vue-styled-components';
import { BLUE, GRAY, square } from '@/styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    GRAY_100_SPAN,
} from '@/styles/common.styled.component';

import * as I from '@components/Dashboard/common/WidgetSettingPanel/options/styles';

export const CreateTransferWrapper = styled.div`
    & #commonDropboxWrapper {
        flex-direction: column;
        top: 35px;
        right: 0;
    }
`;

export const DropdownWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    position: relative;
    width: 100%;

    & #commonDropboxWrapper {
        flex-direction: column;
        top: 35px;
        right: 0;
    }
`;

export const InputWrapper = styled(FLEX_COLUMN_DIV, { disabled: Boolean })`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .input-field {
        margin: 0 auto;
        width: 100%;
        & > input {
            max-width: unset;
            width: 100%;
            margin-left: unset;
        }
    }
    .checkbox-wrapper {
        justify-content: flex-end;
    }
    ${({ disabled }) =>
        disabled &&
        css`
            position: relative;
            &::after {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background: rgba(244, 246, 248, 0.5);
                cursor: not-allowed;
            }
        `}
`;

export const HelpText = styled(GRAY_100_SPAN)`
    font-size: 13px;
    margin-top: 4px;
    text-align: right;
    white-space: pre-line;
    word-break: break-word;
`;

export const MainTitle = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const MainTitleTop = styled(FLEX_VERTICAL_CENTER_DIV)`
    color: ${GRAY(100)};

    & > a {
        height: 22px;
    }

    & svg {
        margin-right: 8px;
        &:hover {
            cursor: pointer;
        }

        &.help-icon {
            margin-left: 8px;
            ${square(16)};
        }
    }
`;

export const LeftWrapper = styled(FLEX_COLUMN_DIV)`
    font-size: 20px;
    font-weight: 500;
    color: ${GRAY(100)};
`;

export const SelectSourceWrapper = styled(FLEX_COLUMN_DIV)`
    margin-bottom: 20px;
    & > div {
        margin-bottom: 20px;
    }
    & > :last-child {
        margin-bottom: unset;
    }
`;

export const ConfigTitleWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-bottom: 8px;
    & .info-icon {
        ${square(15)};
        fill: #949aa1;
        margin-left: 6px;
    }
`;

export const ConfigTitle = styled(GRAY_100_SPAN)`
    font-size: 14px;
    font-weight: 500;
`;

export const ConfigSubTitle = styled.span`
    color: ${GRAY(40)};
    font-size: 12px;
    margin-bottom: 20px;
`;

export const ConfigBottomDescription = styled(ConfigSubTitle)`
    text-align: right;
    width: 100%;
`;

export const ConfigWrapper = styled(FLEX_COLUMN_DIV)``;

export const PreviewButton = styled.button`
    align-self: self-end;
    background: ${BLUE(60)};
    padding: 10px 14px;
    color: #fff;
`;

export const PeriodWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const PeriodWarning = styled.div`
    display: flex;
    margin-top: 8px;
`;

export const DestinationWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    & > svg,
    img {
        margin-right: 8px;
        ${square(24)};
    }
`;
export const SelectStreamDescription = styled(GRAY_100_SPAN)`
    font-size: 16px;
`;

export const StreamOptionsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-top: 40px;
`;

export const StreamItemWrapper = styled(FLEX_COLUMN_DIV, { selected: Boolean })`
    background: ${({ selected }) => (selected ? BLUE(5) : GRAY(10))};
    border-radius: 4px;
    width: 100%;
    padding: 16px;
    height: 160px;
    &:first-child {
        margin-right: 8px;
    }

    & svg {
        fill: ${({ selected }) => (selected ? BLUE(60) : GRAY(100))};
    }

    ${({ selected }) =>
        selected &&
        css`
            border: 1px solid ${BLUE(60)};
            & span {
                color: ${BLUE(60)};
            }
        `}

    &:hover {
        cursor: pointer;
    }

    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const StreamItemTitle = styled(GRAY_100_SPAN)`
    font-weight: 500;
`;

export const StremItemDescription = styled(GRAY_100_SPAN)`
    font-size: 13px;
`;

export const EditStreamWrapper = styled(FLEX_COLUMN_DIV, { disabled: Boolean })`
    background: ${({ disabled }) => (disabled ? GRAY(15) : GRAY(10))};
    padding: 16px;
    margin-bottom: 12px;
`;

export const EditStreamTitle = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-bottom: 12px;
    color: ${GRAY(100)};

    & > svg {
        margin-right: 8px;
    }
`;

export const EditStreamOptionsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)``;

export const EdtiStreamOptionItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    selected: Boolean,
    disabled: Boolean,
})`
    width: 100%;
    background: ${({ selected, disabled }) =>
        selected ? BLUE(10) : disabled ? GRAY(15) : '#fff'};
    padding: 8px 16px;
    border-radius: 2px;
    border: 1px solid ${({ selected }) => (selected ? BLUE(60) : GRAY(30))};

    &:first-child {
        margin-right: 8px;
    }

    & svg {
        fill: ${({ selected }) => (selected ? BLUE(60) : GRAY(100))};
        margin-right: 8px;
    }

    ${({ selected }) =>
        selected &&
        css`
            & span {
                color: ${BLUE(60)};
            }
        `};

    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const TableWrapper = styled(FLEX_COLUMN_DIV)`
    border-radius: 2px;
    border: 1px solid ${GRAY(20)};

    & .option-wrapper {
        background-color: #fff;
        border: unset;
        border-top: 1px dashed ${GRAY(20)};

        & .option-title {
            background: #fff;
        }
    }

    & .item-wrapper {
        background: #fff;
        margin: 8px 12px;
        border: 1px solid ${GRAY(20)};
        padding: 8px 12px;
        margin-top: unset;
        border-radius: 2px;
    }
`;

export const TableTitleWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    cursor: String,
})`
    background: ${GRAY(10)};
    padding: 11px 16px;
    border-bottom: 1px solid ${GRAY(20)};
    color: ${GRAY(100)};
    font-weight: 500;
    & svg {
        margin-right: 8px;
    }

    & .plus-icon {
        ${square(16)};
        fill: ${BLUE(60)};
        margin-right: unset;
        cursor: pointer;
    }

    ${({ cursor }) =>
        cursor &&
        css`
            cursor: ${cursor};
        `}
`;

export const TableBreakdownWrapper = styled(FLEX_VERTICAL_CENTER_DIV, {
    disabled: Boolean,
})`
    padding: 8px 12px;
    flex-wrap: wrap;
    background: ${({ disabled }) => (disabled ? GRAY(15) : '#fff')};
    & > :not(:last-child) {
        margin-right: 24px;
    }
    ${({ disabled }) =>
        disabled &&
        css`
            & > div {
                cursor: not-allowed;
                & > div {
                    cursor: not-allowed;
                    & > div {
                        cursor: not-allowed;
                    }
                }
            }
        `}
`;

export const TableBreakdownCheckItem = styled(FLEX_VERTICAL_CENTER_DIV)`
    color: ${GRAY(100)};
    font-size: 13px;

    & .checkbox-wrapper {
        margin-right: 8px;
    }
`;

export const TableTitleWithIconWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    width: 100%;
    justify-content: space-between;
`;

export const CustomFieldPlaceholder = styled.span`
    font-size: 13px;
    color: ${GRAY(40)};
    margin-top: 8px;
    cursor: pointer;
    width: 100%;
`;

export const ItemBox = styled(I.ItemBox)`
    & > svg {
        fill: ${BLUE(60)};
        cursor: pointer;
    }
`;

export const CustomFieldsItemWrapper = styled(TableBreakdownWrapper)`
    padding-top: unset;

    & > :not(:last-child) {
        margin-right: 4px;
    }
`;

export const EditorWrapper = styled.div`
    margin-top: 20px;
    border: 1px solid ${GRAY(30)};
    border-radius: 2px;

    & .editor {
        height: calc(100vh - 450px);
        overflow: auto;
    }
`;

export const MetricTypeEditorWrapper = styled.div`
    margin-top: 20px;
    padding: 16px;
    background: ${GRAY(10)};
    min-height: 50px;

    & .editor-description {
        margin-bottom: 10px;
        justify-content: space-between;
        font-size: 14px;
        font-weight: 500;
        color: ${GRAY(120)};

        svg {
            cursor: pointer;
        }
    }

    & .metric-editor {
        .cm-content {
            padding: 14px;
            background: #ffffff;
            border: solid 1px #dfe3e5;
        }
        .cm-gutters {
            display: none;
        }
        .cm-placeholder {
            font-size: 13px;
            color: #949aa1;
        }
        .cm-focused {
            outline: 1px solid #0054c6;
        }
        .cm-activeLine {
            background-color: unset;
        }

        /* autocomplete dropdown */
        .cm-tooltip-autocomplete {
            width: 300px;
            max-height: 240px;
            border: 1px solid #dfe3e5;
            background-color: #ffffff;
            font-size: 13px;
            font-weight: 400;
            color: #080a0d;
        }
        .cm-tooltip-autocomplete ul {
            width: 100%;
            max-height: 240px !important;

            li {
                display: flex;
                justify-content: start;
                align-items: center;
                padding: 9px 9px 9px 5px !important;

                .cm-completionIcon {
                    width: 0;
                }

                .cm-completionLabel {
                    width: 100%;
                    word-break: break-all;
                    white-space: break-spaces;
                    line-height: 18px;
                }

                .cm-completionMatchedText {
                    background-color: #b7e3ff;
                    text-decoration-line: none;
                }
            }

            li[aria-selected] {
                background: #0000000d;
                color: #080a0d;
            }
        }

        .cm-line > span {
            display: inline-block;
        }

        .cm-metric {
            position: relative;
            color: #0054c6;
            background-color: #dee9f8;
            border-radius: 12px;
            font-size: 13px;

            &::before {
                content: '';
                display: block;
                width: 11px;
                height: 18px;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 10;
                background-color: #dee9f8;
                border-bottom-left-radius: 12px;
                border-top-left-radius: 12px;
            }

            &::after {
                content: '';
                display: block;
                width: 11px;
                height: 18px;
                position: absolute;
                right: 0;
                bottom: 0;
                z-index: 10;
                background-color: #dee9f8;
                border-bottom-right-radius: 12px;
                border-top-right-radius: 12px;
            }
        }

        .cm-editor ::selection {
            background-color: #1890ff !important;
        }
    }
`;

export const FormatErrorContainer = styled.div`
    height: 20px;
`;

export const FormatError = styled.div`
    text-align: end;
    font-size: 13px;
    font-weight: 400;
    color: #b1000c;
`;

export const DimensionTypeEditorWrapper = styled.div`
    margin-top: 20px;
    height: calc(100vh - 450px);
    overflow: auto;
`;

export const DimensionTitleWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const CustomFieldNameWrapper = styled(FLEX_COLUMN_DIV)`
    margin-top: 20px;

    & .name-title {
        margin-bottom: 4px;
        font-weight: 500;
    }
`;

export const CustomFIeldPanelDesc = styled(GRAY_100_SPAN)`
    font-size: 15px;
    font-weight: 500;
`;

export const CustomFieldNameDesc = styled(FLEX_COLUMN_DIV)`
    & span {
        color: ${GRAY(60)};
        font-size: 13px;
    }
`;

export const CustomFieldTemplateAreaWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-top: 20px;
    justify-content: space-between;

    & .info-icon {
        ${square(20)};
    }
`;

export const TooltipWrapper = styled(FLEX_DIV)`
    font-size: 14px;
    & .info-icon-tooltip {
        ${square(20)};
        min-width: 20px;
        margin-right: 8px;
    }
`;

export const DropdownButtonWrapper = styled.div`
    & .text-area {
        padding: 0 24px;
    }

    & .ant-dropdown-trigger {
        padding: 0 14px;
    }
`;
export const TableNameWrapper = styled(FLEX_COLUMN_DIV)``;

export const TeamplateDropdownItemWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    & .trash-icon {
        ${square(12)};
    }
`;

export const TemplateDropdownBoxWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    & .circle-icon {
        ${square(16)};
        min-width: 16px;
        & path {
            fill: ${GRAY(40)};
        }
        margin-right: 8px;
    }

    & > span {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        max-width: 100%;
    }
`;

export const TemplateBoxWrapper = styled.div`
    & .template-box-wrapper {
        width: 200px;
    }
`;

export const NewTemplateModalTitle = styled.div`
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
`;

export const ApplyAddBtnCss = css`
    gap: 4px;
    width: 80px;
    height: 32px;
    padding: 0 16px;
    border-radius: 50px;
    font-size: 13px;
`;

export const ResetButton = styled.button`
    padding-left: 20px;
    color: ${BLUE(60)};
    font-weight: 500;
`;

export const SpaceHolder = styled.div`
    height: 15px;
`;

export const CommonButtonContainer = styled.div`
    width: 100%;
    margin-top: 10px;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
    flex: 1;

    & .add-if-else-button {
        min-width: 60%;
    }
`;
// flex-direction: column;

export const FieldOptionItemWrapper = styled(FLEX_COLUMN_DIV, {
    selected: Boolean,
})`
    background: ${({ selected }) => (selected ? BLUE(5) : GRAY(10))};
    border-radius: 4px;
    width: 100%;
    padding: 16px;
    height: 160px;
    &:first-child {
        margin-right: 8px;
    }

    & svg {
        fill: ${({ selected }) => (selected ? BLUE(60) : GRAY(100))};
    }

    ${({ selected }) =>
        selected &&
        css`
            border: 1px solid ${BLUE(60)};
            & span {
                color: ${BLUE(60)};
            }
        `}

    &:hover {
        cursor: pointer;
    }
`;

export const FieldOptionTitle = styled(GRAY_100_SPAN)`
    font-weight: 500;
`;

export const FieldOptionItemDescription = styled(GRAY_100_SPAN)`
    font-size: 13px;
`;

export const FieldOptionsDescription = styled(GRAY_100_SPAN)`
    font-size: 16px;
`;

export const FieldOptionsWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    margin-top: 40px;
`;

export const TargetFieldSettingWrapper = styled(I.ListWrapper)`
    margin-bottom: 20px;
    &:hover {
        cursor: pointer;
    }

    & .filter-icon-wrapper {
        & > svg {
            margin-right: 8px;
        }
    }
`;

export const TargetFieldSettingDescription = styled(GRAY_100_SPAN)`
    padding: 12px 16px;
    color: #949aa1;
    background: #fff;
    font-size: 14px;
`;

export const EditButtonText = styled.div`
    font-size: 14px;
    color: ${BLUE(60)};
`;
